import { useEffect, useState } from "react";
import { ref, get, child } from "firebase/database";
import { db } from "./firebase.js";
import * as d3 from "d3";
import Genders from "./analysis/genders.jsx";
import Images from "./analysis/images.jsx";
import diamondData from '../../data/diamond_data.js';
import imagesFile from './../../data/images_data_20250320.json'

function Analysis (props) {

  const [data, setData] = useState([]);

  const [dataParticipants, setDataParticipants] = useState([])
  const [dataGenders, setDataGenders] = useState([])
  const [dataImages, setDataImages] = useState([])

  const handleClick = async () => {
      try {
        const dbRef = ref(db); // e.g. 'users/' or 'messages/123'
        const snapshot = await get(dbRef);
        if (snapshot.exists()) {

          const raw = snapshot.val()
          const objects = Object.entries(raw).map(([key, value]) => ({
              session: key,
              participants: Object.values({...value})
              }));

          function getDataGenders() {

            function getLabel (id) {
              if (['queer', 'nonbinary'].includes(id)) {
                  if (id === 'queer') return 'Genderqueer person'
                  else if (id === 'nonbinary') return 'Nonbinary person'
              }
              else return diamondData.find(el => el.id === id).name
            }

            const dataGendersPrel = ['gen00', 'gen01', 'gen02', 'gen10', 'gen11', 'gen12', 'gen20', 'gen21', 'gen22', 'nonbinary', 'queer'].map(el => {
              return {id: el, answers: []}
            })
  
            objects.forEach(session => {
              session.participants.forEach(participant => {
                participant.test.forEach(answer => {
                  dataGendersPrel.find(gender => gender.id === answer.prompt).answers.push(answer)
                })
              })
            })
  
            const dataGenders = dataGendersPrel.map(gender => {
              const answers = gender.answers
              var matchRight = 0, matchClose = 0, matchWrong = 0;
              var binaryAnswers = 0
  
              answers.forEach(answer => {
                if (['gen20', 'gen02'].includes(answer.answer)) binaryAnswers += 1
  
                if (['queer', 'nonbinary'].includes(answer.prompt)) {
                    if (['gen20', 'gen02'].includes(answer.answer)) matchWrong += 1
                    else matchRight += 1
                } else {
                    if (answer.answer === answer.prompt) matchRight += 1
                    else {
                        const aF = +answer.answer[4],
                            aM = +answer.answer[3],
                            pF = +answer.prompt[4],
                            pM = +answer.prompt[3];
                        
                        if (Math.abs(aF - pF) + Math.abs(aM - pM) < 2) matchClose += 1
                        else matchWrong += 1
                    }
                }
              })

              const distribution = diamondData.map(el => {
                const relevant = answers.filter(item => item.answer === el.id)
                return {
                  id: el.id,
                  value: +d3.format(".2f")(relevant.length / answers.length),
                  answers: relevant
                }
              })
  
              return {
                gender_id: gender.id,
                gender_label: getLabel(gender.id),
                gender_mas: ['nonbinary', 'queer'].includes(gender.id) ? undefined : +gender.id[4],
                gender_fem: ['nonbinary', 'queer'].includes(gender.id) ? undefined : +gender.id[3],
                time_mean: +d3.format(".2f")(d3.mean(answers, d => d.time)),
                report_problem: +d3.format(".2f")(d3.sum(answers, d => d.report_problem) / answers.length),
                report_quality: +d3.format(".2f")(d3.sum(answers, d => d.report_quality) / answers.length),
                match_right: +d3.format(".2f")(matchRight / answers.length),
                match_close: +d3.format(".2f")(matchClose / answers.length),
                match_wrong: +d3.format(".2f")(matchWrong / answers.length),
                binary_answers: +d3.format(".2f")(binaryAnswers / answers.length),
                answers: answers,
                distribution: distribution
              }
            })

            return dataGenders
          }

          function getDataImages() {

            function getLabel (id) {
              if (['queer', 'nonbinary'].includes(id)) {
                  if (id === 'queer') return 'Genderqueer person'
                  else if (id === 'nonbinary') return 'Nonbinary person'
              }
              else return diamondData.find(el => el.id === id).name
            }

            const dataGendersPrel = ['gen00', 'gen01', 'gen02', 'gen10', 'gen11', 'gen12', 'gen20', 'gen21', 'gen22', 'nonbinary', 'queer'].map(el => {
              return {id: el, answers: []}
            })

            const dataImagesPrel = imagesFile.map(el => {
              return {
                ...el,
                answers: []
              }
            })
  
            objects.forEach(session => {
              session.participants.forEach(participant => {
                participant.test.forEach(answer => {
                  dataImagesPrel.find(item => item.file === answer.image).answers.push(answer)
                })
              })
            })

            const dataImages = dataImagesPrel.map(el => {

              const distribution = diamondData.map(gender => {
                const relevant = el.answers.filter(item => item.answer === gender.id)
                return {
                  id: gender.id,
                  value: +d3.format(".2f")(relevant.length / el.answers.length),
                  answers: relevant
                }
              })

              return {
                ...el,
                distribution: distribution
              }
            })

            return dataImages
          }

          function getDataAnswers() {

            function getLabel (id) {
              if (['queer', 'nonbinary'].includes(id)) {
                  if (id === 'queer') return 'Genderqueer person'
                  else if (id === 'nonbinary') return 'Nonbinary person'
              }
              else return diamondData.find(el => el.id === id).name
            }

            const dataAnswersPrel = []
  
            objects.forEach(session => {
              session.participants.forEach(participant => {
                participant.test.forEach(answer => {

                  const umbrella = ['queer', 'nonbinary'].includes(answer.prompt)

                  function getMatch(){
                    if (umbrella) return !['gen20', 'gen02'].includes(answer.answer)
                    else return answer.prompt === answer.answer
                  }

                  const fullAnswer = {
                    ...answer,
                    time: +d3.format(".2f")(answer.time),
                    prompt_m: umbrella ? undefined : +answer.prompt[3],
                    prompt_f: umbrella ? undefined : +answer.prompt[4],
                    prompt_label: getLabel(answer.prompt),
                    answer_m: +answer.answer[3],
                    answer_f: +answer.answer[4],
                    answer_label: getLabel(answer.answer),
                    match: getMatch(),
                    participant_ID: participant.participant,
                    participant_age: participant.general.age,
                    participant_language: participant.general.language,
                    participant_knowledge: +participant.general.knowledge,
                    participant_queer: +participant.general.queer,
                  }
                  dataAnswersPrel.push(fullAnswer)
                })
              })
            })
            console.log('answers', dataAnswersPrel, objects)
            return dataAnswersPrel
          }

          function getDataParticipants() {
            const dataParticipants = []

            objects.forEach(session => {
              session.participants.forEach(participant => {
  
                const answers = participant.test
                var matchRight = 0, matchClose = 0, matchWrong = 0;
                var binaryAnswers = 0
    
                answers.forEach(answer => {
                    if (['gen20', 'gen02'].includes(answer.answer)) binaryAnswers += 1
  
                    if (['queer', 'nonbinary'].includes(answer.prompt)) {
                        if (['gen20', 'gen02'].includes(answer.answer)) matchWrong += 1
                        else matchRight += 1
                    } else {
                        if (answer.answer === answer.prompt) matchRight += 1
                        else {
                            const aF = +answer.answer[4],
                                aM = +answer.answer[3],
                                pF = +answer.prompt[4],
                                pM = +answer.prompt[3];
                            
                            if (Math.abs(aF - pF) + Math.abs(aM - pM) < 2) matchClose += 1
                            else matchWrong += 1
                        }
                    }
                })
  
                const item = {
                  ...participant.general,
                  id: participant.participant,
                  hour: participant.hour,
                  session: session.session,
                  test_length: answers.length,
                  time_mean: d3.format(".2f")(d3.mean(answers, d => d.time)),
                  report_problem: d3.format(".2f")(d3.sum(answers, d => d.report_problem) / answers.length),
                  report_quality: d3.format(".2f")(d3.sum(answers, d => d.report_quality) / answers.length),
                  match_right: d3.format(".2f")(matchRight / answers.length),
                  match_close: d3.format(".2f")(matchClose / answers.length),
                  match_wrong: d3.format(".2f")(matchWrong / answers.length),
                  binary_answers: d3.format(".2f")(binaryAnswers / answers.length),
                }
                dataParticipants.push(item)
              })
            })
            return dataParticipants
          }

          const downloadDataAsJSON = (data, filename = "data.json") => {
            const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
            const url = URL.createObjectURL(blob);
          
            const link = document.createElement("a");
            link.href = url;
            link.download = filename;
            link.click();
          
            URL.revokeObjectURL(url); // Clean up
          };

          const downloadDataAsCSV = (data, filename = "data.csv") => {
            if (!data || !data.length) return;
          
            // Get CSV header from keys of the first object
            const headers = Object.keys(data[0]).join(",");
          
            // Convert each object to a CSV row
            const rows = data.map(row =>
              Object.values(row)
                .map(value =>
                  `"${String(value).replace(/"/g, '""')}"` // Escape quotes
                )
                .join(",")
            );
          
            const csvContent = [headers, ...rows].join("\n");
            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
          
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url); // Clean up
          };

          getDataAnswers()
          const dataParticipants = getDataParticipants()
          const dataGenders = getDataGenders()
          const dataImages = getDataImages()
          const dataAnswers = getDataAnswers()

          downloadDataAsCSV(dataParticipants)
          downloadDataAsCSV(dataGenders)
          downloadDataAsCSV(dataImages)
          downloadDataAsCSV(dataAnswers)

          setDataParticipants(dataParticipants);
          setDataGenders(dataGenders);
          setDataImages(dataImages)
        } else {
          console.log('No data available');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

  function getLabel (id) {
      if (['queer', 'nonbinary'].includes(id)) {
          if (id === 'queer') return 'Genderqueer person'
          else if (id === 'nonbinary') return 'Nonbinary person'
      }
      else return diamondData.find(el => el.id === id).name
  }

  useEffect(() => {
  });

  return (
    <div id="results">
      <div>
          <div 
            style={{
              display: 'flex',
              justifyContent: 'center',
              margin: '0 0 0.5em 0'
            }}
            >
            <button 
              className="button_primary" 
              onClick={handleClick}
              style={{width: 'auto'}}
              >Update data
            </button>
          </div>
          <Genders 
            data = {dataGenders}
          />
          <Images 
            data = {dataImages}
          />
      </div>
    </div>
  );
}

export default Analysis;
